import { Controller } from "@hotwired/stimulus"

// Управляет режимом интервала плейлиста (Fixed / Custom) на форме редактирования.
//
// Fixed  — интервал у всех табов один и тот же (значение первого таба):
//          изменение интервала любого таба применяется ко всем; новый таб
//          получает то же значение. Refresh при этом остаётся индивидуальным.
// Custom — у каждого таба свой интервал; новый таб получает дефолт (defaultValue).
//
// При переключении Custom → Fixed, когда у табов разные интервалы, спрашиваем
// подтверждение: индивидуальные значения будут сброшены к значению первого таба.
//
// Новые строки добавляет cocoon (link_to_add_association) — реагируем через
// intervalTargetConnected, который для стартовых табов срабатывает ДО connect()
// (флаг `ready` отличает начальную загрузку от таба, добавленного пользователем).
export default class extends Controller {
  static targets = ["interval", "banner", "radio"]
  static values = {
    default: { type: Number, default: 10 },
    confirmMessage: String,
  }

  connect() {
    this.applyMode()
    this.ready = true
  }

  get mode() {
    const checked = this.radioTargets.find((r) => r.checked)
    return checked ? checked.value : "fixed"
  }

  // change по radio-кнопкам сегмента Fixed / Custom
  switchMode(event) {
    if (event.target.value === "fixed" && this.intervalsDiffer()) {
      if (!window.confirm(this.confirmMessageValue)) {
        const custom = this.radioTargets.find((r) => r.value === "custom")
        if (custom) custom.checked = true
        return
      }
      this.syncAll(this.firstInterval())
    }
    this.applyMode()
  }

  // input по любому полю интервала — в Fixed синхронизируем остальные
  syncInterval(event) {
    if (this.mode === "fixed") this.syncAll(event.target.value)
  }

  // Таб добавлен через cocoon: назначаем значение по режиму
  intervalTargetConnected(input) {
    if (!this.ready) return
    if (this.mode === "fixed") {
      input.value = this.firstInterval() ?? this.defaultValue
    } else if (input.value === "") {
      input.value = this.defaultValue
    }
  }

  applyMode() {
    if (this.hasBannerTarget) this.bannerTarget.hidden = this.mode !== "fixed"
  }

  // --- helpers -------------------------------------------------------------

  // Поля интервала видимых табов (исключаем строки, помеченные cocoon на удаление)
  activeIntervals() {
    return this.intervalTargets.filter((input) => !this.isRemoved(input))
  }

  isRemoved(input) {
    const row = input.closest(".nested-fields")
    if (!row) return false
    if (row.style.display === "none") return true
    const destroy = row.querySelector("input[name*='_destroy']")
    return !!destroy && (destroy.value === "true" || destroy.value === "1")
  }

  firstInterval() {
    const inputs = this.activeIntervals()
    return inputs.length ? inputs[0].value : null
  }

  intervalsDiffer() {
    const values = this.activeIntervals().map((input) => input.value)
    return values.some((value) => value !== values[0])
  }

  syncAll(value) {
    const target = String(value)
    this.activeIntervals().forEach((input) => {
      if (input.value !== target) input.value = target
    })
  }
}
